import styled from "styled-components";

export const WppLink = styled.a`
  :hover {
    transform: scale(1.04);
    transition: transform 0.5s;
  }
`;
